import {connect} from 'react-redux';

import {setNotificationAction} from '@pluto/notification/Redux/NotificationActions';
import LoginContainer from './LoginContainer';
import {logInAction, logOutAction} from './Redux/LoginActions';

export const mapState = (state: any) => {
    return {
        token: state.token,
        isAuthenticated: state.user.isAuthenticated,
    };
};

export const mapDispatch = {
    logIn: logInAction,
    logOut: logOutAction,
    setNotification: setNotificationAction,
};

export default connect(mapState, mapDispatch)(LoginContainer);
